import { useCallback, useMemo } from 'react';
import { useQuery } from '@shared/react';
import { fixRadioFilterQuery } from './fixRadioFilterQuery';

interface Options {
    initialRadioOption: string;
    allowedValues: string[];
    queryName?: string;
}

interface Returned {
    queryRadioOption: string;
    setQueryRadioOption: (searchString: string) => void;
}

export function useRadioFilterQuery(options: Options): Returned {
    const { initialRadioOption, allowedValues, queryName } = options;

    const [query, setQuery] = useQuery();

    const setQueryRadioOption = useCallback(
        (value: string) => {
            if (queryName) setQuery(queryName, value);
        },
        [setQuery, queryName],
    );

    const fixedQueryRadioOptions = useMemo(
        () =>
            fixRadioFilterQuery({
                initialRadioOption,
                query,
                queryName,
                allowedValues,
            }),
        [initialRadioOption, query, queryName, allowedValues],
    );

    return {
        queryRadioOption: fixedQueryRadioOptions,
        setQueryRadioOption,
    };
}
